import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import AreaInfoBody from './AreaInfoBody';

// Edit: mostra mesma view e um sidebar (mesmo que vazio) para consistência.
const AreaInfoEdit = (props) => {
  const { content, selected } = props;
  return (
    <>
      <AreaInfoBody content={content} isEditMode />
      <SidebarPortal selected={selected}>
        {/* Placeholder futuro para configurações */}
      </SidebarPortal>
    </>
  );
};

AreaInfoEdit.propTypes = {
  content: PropTypes.object,
  selected: PropTypes.bool,
};

export default AreaInfoEdit;
